import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { INSTAGRAM_URL, CONTACT_EMAIL, HANDSTYLE } from "../lib/brand";
import { useNavItems } from "../lib/nav";

export default function Footer() {
  const items = useNavItems();
  const [f, setF] = useState({
    tagline: "An ongoing artistic practice and archive.",
    instagram_url: INSTAGRAM_URL,
    email: CONTACT_EMAIL,
  });

  useEffect(() => {
    api.get("/settings/footer").then((r) => {
      if (r.data?.data) setF((prev) => ({ ...prev, ...r.data.data }));
    }).catch(() => {});
  }, []);

  return (
    <footer data-testid="main-footer" className="border-t hairline mt-24 md:mt-40">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-20 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <img src={HANDSTYLE} alt="RCKT" className="h-16 md:h-24 w-auto" />
            <p className="label mt-6" data-testid="footer-tagline">{f.tagline}</p>
          </div>

          <div className="md:col-span-3 md:col-start-8 flex flex-col gap-3">
            <span className="label mb-1">Index</span>
            {items.map((i) => (
              <Link key={i.key} to={i.to} data-testid={`footer-nav-${i.key}`} className="text-sm hover:opacity-50 transition-opacity">{i.footerLabel}</Link>
            ))}
          </div>

          <div className="md:col-span-2 flex flex-col gap-3">
            <span className="label mb-1">Elsewhere</span>
            <a href={f.instagram_url} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="text-sm hover:opacity-50 transition-opacity">Instagram</a>
            <a href={`mailto:${f.email}`} data-testid="footer-email" className="text-sm hover:opacity-50 transition-opacity break-all">{f.email}</a>
            <Link to="/admin" className="text-sm opacity-40 hover:opacity-100 transition-opacity">Archive Admin</Link>
          </div>
        </div>

        <div className="mt-16 md:mt-24 pt-6 border-t hairline flex flex-col md:flex-row justify-between gap-3">
          <span className="label">© {new Date().getFullYear()} RCKT</span>
        </div>
      </div>
    </footer>
  );
}
